import { useEffect, MouseEvent, HTMLElement } from 'react'
import useAuth from 'app/hooks/useAuth'
import { H6, Small } from '../Typography'
import { Box, styled, useTheme } from '@mui/system'
import { TextField, Menu } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import useSettings from 'app/hooks/useSettings'
import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { themeShadows } from '../MatxTheme/themeColors'
import { sideNavWidth, topBarHeight } from 'app/utils/constant'
import enLocale from "date-fns/locale/en-US";
import {
    getShift
} from 'app/redux/actions/UtilsActions'
import {
    Icon,
    Badge,
    IconButton,
    Drawer,
    Button,
    ThemeProvider,
} from '@mui/material'
import { DatePicker, StaticDatePicker, LocalizationProvider } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'

enLocale.options.weekStartsOn=1

let hasData = false;

function ShiftPicker({ handleShiftChange}) {
    
    const [shift, setShift] = useState(null)
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [date, setDate] = useState(new Date())
    const [displayDate, setDisplayDate] = useState('')
    const dispatch = useDispatch()
    const { shifts } = useSelector(
        (state) => state.utils
    )
    const { settings } = useSettings()
    const theme = useTheme()
    const secondary = theme.palette.text.secondary

    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    /*if (!cartListLoaded) {
        dispatch(getCartList(user.id))
        cartListLoaded = true
    }*/

    //On close
    const handleDrawerToggle = () => {
        setAnchorEl(null)
        handleShiftChange(date, shift)
    }

    const handleDateChange = (newVal) => {
        console.log("Date Change")
        setDisplayDate(formatDate(newVal))
        setDate(newVal)
        handleShiftChange(newVal, shift)
    }


    const nextShift = () => {
        let idx = selectedIndex
        let dt = date
        if(selectedIndex < shifts.length-1){
            idx = idx+1
        }else{
            idx = 0
            dt.setDate(dt.getDate()+1)
        }
        setSelectedIndex(idx)
        setShift(shifts[idx])
        setDate(dt)
        setDisplayDate(formatDate(dt))
        if(anchorEl === null){
            handleShiftChange(dt, shifts[idx])
        }
    }

    const previousShift = () => {
        let idx = selectedIndex
        let dt = date
        
        if(idx > 0){
            idx = idx-1;
        }else{
            dt.setDate(dt.getDate()-1)
            idx = shifts.length-1
        }

        setSelectedIndex(idx)
        setShift(shifts[idx])
        setDate(dt)
        setDisplayDate(formatDate(dt))

        if(anchorEl === null){
            handleShiftChange(dt, shifts[idx])
        }
    }

    if(!hasData){
        dispatch(getShift())
        hasData = true
    }


    useEffect(() => {
        if(shift==null){
            shifts.forEach((val, idx)=>{
                
                let shiftStart = parseShiftTime(val.start_time)
                let shiftEnd = parseShiftTime(val.end_time)
                let currentTime = getTimeOfTheDayInMinute(date)

                if(currentTime>=shiftStart && currentTime<=shiftEnd){
                    setSelectedIndex(idx)
                    setShift(val)
                    setDisplayDate(formatDate(date))
                    handleShiftChange(date, val)
                }
            })
        }
        
    }, [shifts])

    const { palette } = useTheme()
    const textColor = palette.text.primary

    const getTimeOfTheDayInMinute = (d) =>{
        return d.getHours()*60*60+d.getMinutes()*60+d.getSeconds()
    }

    const parseShiftTime = (str) => {
        let strs = str.split(':')
        return parseInt(strs[0])*60*60+parseInt(strs[1])*60+parseInt(strs[2])
    }

    const formatDate = (date)=>{
        let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
        let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
        let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
        return `${da}-${mo}-${ye}`
    }

    return (
        <Fragment>
            <Box
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                textAlign="right"
                style={{display:'inline-block'}}
            >
                <IconButton onClick={previousShift}>
                    <Icon sx={{ color: textColor }}>arrow_left</Icon>
                </IconButton>

                <Button onClick={handleClick}>{shift?shift.shift_name:"-"} {displayDate} </Button>

                <IconButton onClick={nextShift}>
                    <Icon sx={{ color: textColor }}>arrow_right</Icon>
                </IconButton>
            </Box>
            <ThemeProvider theme={settings.themes[settings.activeTheme]}>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleDrawerToggle}
                >
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={enLocale}>
                        <Box
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                        >
                            <IconButton onClick={previousShift}>
                                <Icon sx={{ color: textColor }}>
                                    arrow_left
                                </Icon>
                            </IconButton>
                            {shift?shift.shift_name:"-"} {displayDate}
                            <IconButton onClick={nextShift}>
                                <Icon sx={{ color: textColor }}>
                                    arrow_right
                                </Icon>
                            </IconButton>
                        </Box>
                        <StaticDatePicker
                            
                            displayStaticWrapperAs="desktop"
                            value={date}
                            onChange={handleDateChange}
                            renderInput={(props) => (
                                <TextField
                                    {...props}
                                    // variant="Outlined"
                                    id="mui-pickers-date"
                                    label="Date picker"
                                    sx={{ mb: 2, width: '100%' }}
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Menu>
            </ThemeProvider>
        </Fragment>
    )
}

export default ShiftPicker
